import React from "react";
import { IonSkeletonText } from "@ionic/react";

const SkeltonItemContent = () => {
  return (
    <div style={{ width: "100%" }}>
      <IonSkeletonText animated style={{ width: "20%", marginTop: "14px" }} />
      <IonSkeletonText
        animated
        style={{
          width: "100%",
          padding: "2px 0",
          margin: "18px 0 0 0",
        }}
      />
      <IonSkeletonText animated style={{ height: "10px", width: "0%" }} />
    </div>
  );
};

export default SkeltonItemContent;
